export default "__VITE_ASSET__CTkTN1np__"